import { Text } from 'components/ui';
import { format } from 'date-fns';
import { ListingRead } from 'lib/api/generated';
import {
  formattedSoldPrices,
  getListingStatusLabel,
  getPriceType,
} from 'lib/helpers';
import { rgba } from 'polished';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { DATE_FORMAT } from 'settings/config';
import styled from 'styled-components';
import { globalTheme } from 'styles/global-theme';

const SoldContainer = styled.div`
  margin: ${globalTheme.space[0]} 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${globalTheme.space[0]} ${globalTheme.space[2]};
  border-radius: ${globalTheme.space[0]};
`;

interface ListingsDetailProps {
  listingDetails: ListingRead;
  publicListingData?: ListingRead;
}

function SoldBanner({
  listingDetails,
  publicListingData,
}: ListingsDetailProps) {
  let under_offer,
    sold,
    sold_price,
    sold_buyer,
    sold_price_type,
    sold_hide_price,
    org,
    type,
    metadata,
    price_method;

  if (publicListingData) {
    ({
      under_offer,
      sold,
      sold_price,
      sold_buyer,
      sold_price_type,
      sold_hide_price,
      org,
      type,
      metadata,
      price_method,
    } = publicListingData);
  } else {
    ({
      under_offer,
      sold,
      sold_price,
      sold_buyer,
      sold_price_type,
      sold_hide_price,
      org,
      type,
      metadata,
      price_method,
    } = listingDetails);
  }

  const isAuction = price_method === 'AUCTION';

  return (
    <>
      {(sold || under_offer) && (
        <SoldContainer
          style={{
            backgroundColor: rgba(
              sold ? globalTheme.colors.red : globalTheme.colors.blue,
              0.15
            ),
            color: sold ? globalTheme.colors.red : globalTheme.colors.blue,
          }}
        >
          <Text fontSize={3} textAlign='center' fontWeight='semiBold'>
            {(() => {
              const label = sold
                ? isAuction
                  ? 'Auctioned'
                  : getListingStatusLabel(type)
                : 'Under Offer';
              const datePrefix = sold ? 'on' : 'since';
              const dateVal = sold || under_offer;
              const dateStr = dateVal
                ? ` ${datePrefix} ${format(
                    new Date(dateVal),
                    DATE_FORMAT.listing
                  )}`
                : '';

              const canSeePrice = metadata?.is_org_member;
              const priceStr =
                sold_price && sold_price_type && canSeePrice && !sold_hide_price
                  ? ` for ${formattedSoldPrices(
                      sold_price,
                      sold_price_type
                    )}${getPriceType(sold_price_type)}`
                  : '';

              const canSeeBuyer = metadata?.is_org_member;
              const buyerStr =
                canSeeBuyer && sold_buyer ? ` to ${sold_buyer}` : '';

              return `${label}${dateStr}${priceStr}${buyerStr}`;
            })()}
          </Text>
        </SoldContainer>
      )}
    </>
  );
}
export default SoldBanner;
